import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  withStyles,
  Grid,
  Typography,
} from '@material-ui/core';

import {
  formatDateString,
  getThisMonthAtMidnight,
} from '../../../../../utils/dateHelper';

import styles from './styles';
import KpiCards from './KpiCards';
import EventCreationTrendingCard from './EventCreationTrendingCard';
import EventsByTagCard from './EventsByTagCard';
import UserActionsCard from './UserActionsCard';
import EventCompletionTimesCard from './EventCompletionTimesCard';

export class AnalyticsViewComponent extends React.Component {
  getSearchStartTime = () => ((this.props.dashboardData
      && this.props.dashboardData.startDate)
    ? formatDateString(this.props.dashboardData.startDate)
    : formatDateString(getThisMonthAtMidnight()))

  getSearchEndTime = () => ((this.props.dashboardData
      && this.props.dashboardData.endDate)
    ? formatDateString(this.props.dashboardData.endDate)
    : formatDateString(new Date()))

  render() {
    const {
      classes,
      analytics,
      loading,
      users,
    } = this.props;

    return (
      <div className={classes.root}>
        <Typography variant="caption" className={classes.greyColor}>
          Showing data for <b>{`${this.getSearchStartTime()} `}</b>
          through <b>{this.getSearchEndTime()}</b>
        </Typography>

        <KpiCards analytics={analytics} loading={loading} />

        <Grid container spacing={4}>
          <Grid item xs md={6} className={classes.gridItem}>
            <EventCreationTrendingCard analytics={analytics} loading={loading} />
          </Grid>
          <Grid item xs md={6} className={classes.gridItem}>
            <EventsByTagCard analytics={analytics} loading={loading} />
          </Grid>
          <Grid item xs md={6} className={classes.gridItem}>
            <UserActionsCard analytics={analytics} loading={loading} users={users} />
          </Grid>
          <Grid item xs md={6} className={classes.gridItem}>
            <EventCompletionTimesCard analytics={analytics} loading={loading} />
          </Grid>
        </Grid>

      </div>

    );
  }
}

AnalyticsViewComponent.propTypes = {
  classes: PropTypes.object,
  dashboardData: PropTypes.object,
  analytics: PropTypes.object,
  loading: PropTypes.bool,
  users: PropTypes.array,
};

AnalyticsViewComponent.defaultProps = {
  classes: {},
  dashboardData: { },
  analytics: {},
  loading: false,
  users: [],
};

export const mapStateToProps = (state) => ({
  dashboardData: state.dashboard.currentFilterDashboard.dashboardData

    ? state.dashboard.currentFilterDashboard.dashboardData
    : {},
  analytics: state.event.analytics,
  loading: state.event.isFetchingAnalytics,
  users: state.tenant.tenantUsers,
});

export const AnalyticsViewConnected = connect(
  mapStateToProps,
  null,
)(withStyles(styles, { withTheme: true })(AnalyticsViewComponent));

export default withRouter(AnalyticsViewConnected);
